angular.module('impactx.approvalincomplete').controller('IncompleteApprovalListCtrl', [
    'selectedListItems',
    IncompleteApprovalListCtrl
]);

function IncompleteApprovalListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'IncompleteApproval'
        },
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/approvalincomplete/templates/incompleteapproval.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/approvalincomplete/list',
        id: "incompleteapproval",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "incompleteapproval/" + selectedListItems.getFirstSelectedId();
    }
}